/* ==========================================================================
 *  Function: init google maps
 * ======================================================================= */
function fn_components_map(){
    $('.map-block').each(function() {
        var inst = $(this);
        var id = inst.attr('id');
        var langitude = inst.data('langitude');
        var longitude = inst.data('longitude');
        fn_init_map(id, langitude, longitude);
    });
}

function fn_init_map(id, langitude, longitude){
    var map;
    var mapOptions = {
        center: new google.maps.LatLng(langitude,longitude),
        zoom: 16,
        zoomControl: true,
        disableDoubleClickZoom: false,
        mapTypeControl: false,
        scaleControl: true,
        scrollwheel: false,
        panControl: true,
        streetViewControl: false,
        draggable : true,
        overviewMapControl: false,
        overviewMapControlOptions: {
            opened: false,
        },
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: mapGray

    }
    var mapElement = document.getElementById(id);
    var map = new google.maps.Map(mapElement, mapOptions);
    var locations = [
        [ langitude,  longitude]
    ];


    var mapMarker = {
        url: 'images/icons/map-marker.svg',
        // This marker is 20 pixels wide by 32 pixels high.
        size: new google.maps.Size(41, 44),
        // The origin for this image is (0, 0).
        origin: new google.maps.Point(0, 0),
        // The anchor for this image is the base of the flagpole at (0, 32).
        anchor: new google.maps.Point(0, 0)
    };

    for (i = 0; i < locations.length; i++) {
        marker = new google.maps.Marker({
            icon: mapMarker,
            position: new google.maps.LatLng(locations[i][0], locations[i][1]),
            map: map
        });
    link = '';     
    }
}